import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // UI state local.
  idHighlight: "",
  idContextMenu: "",
  // UI state global.
  windowLock: false,
  spinner: false,
  spinnerMessage: "initializing",
};

const overlaySlice = createSlice({
  name: "overlay",
  initialState,
  reducers: {
    setHighlight(state, action) {
      state.idHighlight = action.payload;
    },
    setContextMenu(state, action) {
      state.idContextMenu = action.payload;
    },
    setWindowLock(state, action) {
      state.windowLock = action.payload;

      if (state.idContextMenu) {
        state.idContextMenu = "";
      }
    },
    setSpinner(state, action) {
      state.spinner = action.payload;
    },
    setSpinnerMessage(state, action) {
      state.spinnerMessage = action.payload;
    },
  },
});

//-----------------------------------------------------------------------------------

export const getIsAnyHighlighted = (state) => {
  return state.overlay.idHighlight !== "";
}

export const getIsHighlighted = (id) => (state) => {
  return state.overlay.idHighlight === id;
};

export const getIsAnyContextMenuDisplayed = (state) => {
  return state.overlay.idContextMenu !== "";
}

export const getIsContextMenuDisplayed = (id) => (state) => {
  return state.overlay.idContextMenu === id;
};

export const getWindowLock = (state) => {
  return state.overlay.windowLock;
};

export const getSpinner = (state) => {
  return state.overlay.spinner;
};

export const getSpinnerMessage = (state) => {
  return state.overlay.spinnerMessage;
};

//-----------------------------------------------------------------------------------

export default overlaySlice.reducer;
export const {
  setContainerHover,
  setHighlight,
  setContextMenu,
  setWindowLock,
  setSpinner,
  setSpinnerMessage,
} = overlaySlice.actions;
